import React, { useEffect, useRef, useState } from "react";
import "./FrontLayout.css";

import Footer from "../../reusableComponents/Footer/Footer";
import ImageGrid from "../../reusableComponents/ImageGrid/ImageGrid";
import LoginImage from "../../../assets/rebranding/LE_16-9-1.jpg";
import RoyalBridgeFooter from "../../RoyalBridge/RoyalBridgeFooter/RoyalBridgeFooter";
import RoyalMomentumFooter from "../../RoyalMomentum/components/RoyalMomentumFooter";

/** `usedIn` picks the footer: 'mrg' | 'bridge' | 'momentum'. */
const FrontLayout = ({ children, className, bigImage = LoginImage, usedIn = 'mrg' }) => {
    const divARef = useRef(null);
    const divBRef = useRef(null);
    const [divAHeight, setDivAHeight] = useState("100vh");

    const updateHeights = () => {
        if (divBRef.current) {
            const heightB = divBRef.current.offsetHeight;
            setDivAHeight(`calc(100vh - ${heightB}px)`);
        }
    };

    useEffect(() => {
        updateHeights(); // On load

        window.addEventListener("resize", updateHeights); // On resize

        return () => {
        window.removeEventListener("resize", updateHeights);
        };
    }, []);
    return (
        <>
            <div className="relative w-full login">
                {/* <div className="relative flex w-full p-4 ipad:p-0"> */}
                    {/* Image Grid */}
                    {/* <div className="hidden ipad:block ipad:!min-h-screen login__grid flex-1 sticky top-0 self-start">
                        <ImageGrid />
                    </div> */}

                    {/* Login box */}
                    {/* <div className="border border-rebrandRcBlue ipad:m-[20px] flex-none flex items-top justify-center px-10 py-10 ipad:px-[30px] desktop:px-[120px] ipad:py-[40px] w-full ipad:w-auto ipad:min-w-[420px] ">
                        <div className={`desktop:w-[420px] ${className}`}>{children}</div>
                    </div>
                </div> */}
                <div className={`relative grid grid-cols-1 lg:grid-cols-2`}
                    ref={divARef}
                    style={{ minHeight: divAHeight }}>
                    {/* Image Grid */}
                    <div className={`hidden lg:block w-full h-full`}>
                        <img src={bigImage} className="w-full h-full object-cover"/>
                    </div>

                    {/* Login box */}
                    <div className={`px-[50px] lg:px-[112px] py-14 flex justify-center items-center`}>
                        <div className={`${className}`}>{children}</div>
                    </div>
                </div>

                {/* Footer */}
                <div ref={divBRef} className={``}>
                    {usedIn === 'mrg' && (
                        <Footer />
                    )}
                    {usedIn === 'bridge' && (
                        <RoyalBridgeFooter />
                    )}
                    {usedIn === 'momentum' && (
                        <RoyalMomentumFooter />
                    )}
                </div>
            </div>
        </>
    );
};

export default FrontLayout;
